var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "DefaultDialog" } },
    [
      _vm.show
        ? _c(
            "el-dialog",
            {
              staticClass: "sQDialog",
              attrs: {
                visible: _vm.show,
                show: _vm.show,
                "show-close": false,
                "close-on-press-escape": false,
                title: _vm.title,
                "close-on-click-modal": _vm.closeOnClickModal,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.show = $event
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "white-space": "pre-wrap",
                    "word-break": "break-word"
                  }
                },
                [_vm._v(_vm._s(_vm.text))]
              ),
              _vm._v(" "),
              _vm.img
                ? _c("img", {
                    staticClass: "img",
                    attrs: { src: _vm.img, alt: "", srcset: "" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "cancelBtn cursor",
                      on: { click: _vm.yesBtn }
                    },
                    [_vm._v(_vm._s(_vm.yesTxt))]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2898b9bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2898b9bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/defaultDialog/src/main.vue
// module id = null
// module chunks = 